import { createRouter, RouteRecordRaw, createWebHashHistory } from 'vue-router';
import Cookie from 'js-cookie';
import MenuManager from '@/utils/base/getMenu';
import store from '@/store/index';
import websocket from '@/utils/base/socket';

import { initOptionsData } from '@/components/staff/serve';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */'@/views/login/index.vue'),
  },
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: {
      title: '首页',
    },
    component: () => import(/* webpackChunkName: "layout" */'@/layout/index.vue'),
  },
  {
    path: "/repair",
    name: 'repair',
    component: () => import(/* webpackChunkName: "repair" */ '@/views/repair/index.vue'),
  },
  {
    path: '/repairprogress',
    name: 'repairprogress',
    component: () => import(/* webpackChunkName: "repairprogress" */ '@/views/repairprogress/index.vue'),
  },
  {
    path: "/mobilesearchrepair",
    name: "mobileSearchRepair",
    component: () => import(/* webpackChunkName: "mobileSearchRepair" */ '@/views/repair/mobileSearch.vue'),
  },
  {
    path: "/mobileaddrepair",
    name: "mobileAddRepair",
    component: () => import(/* webpackChunkName: "mobileAddRepair" */ '@/views/repair/mobileAddRepair.vue'),
  },
  {
    path: '/mobileentry',
    name: 'mobileEnrty',
    component: () => import(/* webpackChunkName: "mobile" */ '@/views/mobile/entry.vue'),
  },
  {
    path: '/mobilechangepassword',
    name: 'mobilechangepassword',
    component: () => import(/* webpackChunkName: "mobilechangepassword" */ '@/views/mobilechangepassword/index.vue'),
  },
  {
    path: "/swanqualityinspection",
    name: 'swanqualityinspection',
    component: () => import(/* webpackChunkName: "swanqualityinspection" */ '@/views/productDaily/pc/qualityInspection/index.vue'),
  },
  {
    path: "/swanproduce",
    name: "swanProduce",
    component: () => import(/* webpackChunkName: "swanProduce" */ '@/views/productDaily/pc/produce/index.vue'),
  }, {
    path: "/notice",
    name: "notice",
    component: () => import(/* webpackChunkName: "notice" */ '@/views/notice/pc/index.vue'),
  }, {
    path: "/rdprojectlayout",
    name: "rdprojectlayout",
    component: () => import(/* webpackChunkName: "rdprojectlayout" */ '@/views/rdmanagement/projectLayout/index.vue'),
  }, {
    path: "/printInstruction",
    name: "printInstruction",
    component: () => import(/* webpackChunkName: "printInstruction" */ '@/views/productDaily/components/instruction/print/printTable.vue'),
  }, {
    path: "/printRepair",
    name: "printRepair",
    component: () => import(/* webpackChunkName: "printRepair" */ '@/views/afterSaleRepair/pc/printRepair.vue'),
  }, {
    path: "/aftersalevideo",
    name: "aftersalevideo",
    meta: {
      type: "foreign"
    },
    component: () => import(/* webpackChunkName: "aftersalevideo" */ '@/views/afterSale/video/index.vue'),
  }, {
    path: "/aftersalevideodetail",
    name: "aftersalevideodetail",
    meta: {
      type: "foreign"
    },
    component: () => import(/* webpackChunkName: "aftersalevideodetail" */ '@/views/afterSale/video/details.vue'),
  }, {
    path: "/startoninstructions",
    name: "startoninstructions",
    meta: {
      type: "foreign"
    },
    component: () => import(/* webpackChunkName: "startoninstructions" */ '@/views/instructions/starton.vue'),
  }, {
    path: "/aftersalelookvideo",
    name: "aftersalelookvideo",
    meta: {
      type: "foreign"
    },
    component: () => import(/* webpackChunkName: "aftersalelookvideo" */ '@/views/afterSale/video/video.vue'),
  }, {
    path: "/branddetails",
    name: "branddetails",
    meta: {
      type: "foreign"
    },
    component: () => import(/* webpackChunkName: "branddetails" */ '@/views/brand/Catalog/details.vue'),
  }, {
    path: "/brandcatalog",
    name: "brandcatalog",
    meta: {
      title: "产品目录",
      type: 'foreign',
    },
    component: () => import(/* webpackChunkName: "brandcatalog" */ '@/views/brand/Catalog/index.vue'),
  }, {
    path: "/duty",
    name: "Duty",
    meta: {
      title: "声明",
      type: 'foreign',
    },
    component: () => import(/* webpackChunkName: "duty" */ '@/views/BOBO/duty.vue'),
  }, {
    path: "/iolmode",
    name: "IOLMode",
    meta: {
      title: "IOL模式",
      type: 'foreign',
    },
    component: () => import(/* webpackChunkName: "IOLMode" */ '@/views/BOBO/selectMode.vue'),
  }, {
    path: "/printiol",
    name: "PrintIol",
    meta: {
      title: "声明",
      type: 'foreign',
    },
    component: () => import(/* webpackChunkName: "PrintIol" */ '@/views/BOBO/print.vue'),
  }, {
    path: "/calculate",
    name: "Calculate",
    meta: {
      title: "声明",
      type: 'foreign',
    },
    component: () => import(/* webpackChunkName: "calculate" */ '@/views/BOBO/calculate.vue'),
  }, {
    path: "/toricCalculate",
    name: "ToricCalculate",
    meta: {
      title: "声明",
      type: 'foreign',
    },
    component: () => import(/* webpackChunkName: "toricCalculate" */ '@/views/BOBO/toricCalculate.vue'),
  }, {
    path: "/iolresult",
    name: "Result",
    meta: {
      title: "声明",
      type: 'foreign',
    },
    component: () => import(/* webpackChunkName: "calculate" */ '@/views/BOBO/result.vue'),
  }
];

const router = createRouter({
  history: createWebHashHistory('/cloud/index.html'),
  routes,
});

// router.beforeEach(async (to, from, next) => {
//   if (from.fullPath === '/login') {
//     next();
//     return
//   }
//   if (from.fullPath === '/' && to.fullPath !== '/login') {
//     const userInfo = localStorage.getItem('qc_userInfo');
//     if (userInfo === null) {
//       next({
//         path: '/'
//       });
//     }
//     store.commit('SET_USER_INFO', JSON.parse(userInfo));
//   }
//   if (from.fullPath === '/login' && to.fullPath !== '/repair') {
//     next({
//       path: '/'
//     });
//   }
//   else {
//     next();
//   }
// });

/* eslint-disable */
router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.type === 'foreign') return next();
  // 如果刷新页面并且有登录信息前往页面
  if (from.fullPath === '/' && to.fullPath !== '/login') {
    if (store.getters.menu.length > 0) {
      next();
      return false;
    }

    const isLogout = localStorage.getItem('logout');

    const userInfo = JSON.parse(localStorage.getItem('qc_userInfo'));

    if (!userInfo) {
      next({
        path: '/'
      });
    }

    if (isLogout === 'true') {
      next({
        path: '/'
      });
      return;
    }

    store.commit('SET_USER_INFO', userInfo);

    const menuManager = new MenuManager(userInfo.id);
    websocket.Init(userInfo.id);
    console.log('init ');
    // 没有路由列表 获取路由和权限做匹配
    await menuManager.findRoute().then((res: any) => {
      if (res.length === 0) {
        next();
        return;
      }
      next({ ...to, replace: true });
      initOptionsData();
    });
    // 登录页限制
  } else if (from.fullPath === '/login' && (to.fullPath !== '/home' && to.fullPath !== '/mobileentry' && to.fullPath !== '/rnddepartmentAnnouncement')) {
    next({
      path: '/'
    });
  } else {
    next();
  }
  // 如果刷新页面并且没有登录信息前往登录页
  if (from.fullPath === '/' && to.fullPath !== '/login') {
    next({
      path: '/'
    });
  }
});

/* eslint-disable */

export const loadMenus = (next, to) => {
  next({ ...to, replace: true });
};

export default router;
